<script setup lang="ts">
defineOptions({ name: 'StSidebarNavItem' });

const props = withDefaults(
    defineProps<{
        label: string;
        icon: string;
        href?: string;
        active?: boolean;
        subItem?: boolean;
        count?: number;
        createUrl?: string;
        collapsible?: boolean;
        collapsed?: boolean;
        toggleOnLink?: boolean;
    }>(),
    {
        href: '#',
        active: false,
        subItem: false,
        collapsible: false,
        collapsed: true,
        toggleOnLink: false
    }
);

const emit = defineEmits<{
    (event: 'toggle'): void;
    (event: 'open', url: string): void;
}>();

function onLinkClick(event: MouseEvent): void {
    if (!props.toggleOnLink) return;
    event.preventDefault();
    emit('toggle');
}

function onToggle(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    emit('toggle');
}

function onOpen(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (props.createUrl) emit('open', props.createUrl);
}
</script>

<template>
    <li class="folder-item">
        <div :class="{ 'sub-folder-item': subItem }">
            <div class="folder-item-box">
                <a
                    :href="href"
                    class="nav-link text-white"
                    :class="{ active, 'sidebar-nav-sub-link': subItem, pointer: toggleOnLink }"
                    @click="onLinkClick"
                >
                    <span class="flex-grow-1 sidebar-nav-label">
                        <i :class="[icon, 'sidebar-nav-icon']"></i>
                        <span class="sidebar-nav-text">{{ label }}</span>
                    </span>
                    <span v-if="count !== undefined" class="badge rounded-pill text-bg-dark notranslate nav-link-count-badge">
                        {{ count }}
                    </span>
                    <span v-if="createUrl" class="badge rounded-pill text-bg-dark notranslate nav-link-plus-icon" @click="onOpen">
                        <i class="fas fa-plus"></i>
                    </span>
                    <span v-if="collapsible" class="pointer" @click="onToggle">
                        <i :class="[collapsed ? 'fa-angle-left' : 'fa-angle-down', 'fal', 'sidebar-nav-arrow-icon']"></i>
                    </span>
                </a>
            </div>
        </div>
    </li>
</template>
